export default __webpack_public_path__ + "static/media/ic_Payment_error.75fe9904.svg";